import { Account } from "@wingspanhq/wingspan-api-sdk";

// The logo and the company links are exactly what the business profile form
// writes, so either one being set means the profile was filled in — here, in
// Settings > Marketing, or in Settings > Links.
export const selectorHasBusinessProfile = (account?: Account): boolean => {
  const profile = account?.profile;

  if (profile?.logoFileId) {
    return true;
  }

  return Object.values(profile?.company?.links ?? {}).some(Boolean);
};
